(function($, Drupal, drupalSettings) {

  Drupal.behaviors.visa_exchange_rate_calculator = {
    attach: function (context, settings) {

      // --- Get toolbars height.
      function getToolbarsHeight() {
        var toolbarsHeight = 0;
        if ($('body').hasClass('user-logged-in') && ($('body').hasClass('toolbar-fixed') || $(window).scrollTop() == 0)) {
          toolbarsHeight += $('#toolbar-administration > #toolbar-bar').outerHeight();
          toolbarsHeight += $('#toolbar-item-administration-tray.toolbar-tray-horizontal').is(':visible') ? $('#toolbar-item-administration-tray').outerHeight() : 0;
          toolbarsHeight += $('.region-local-tasks').length ? $('.region-local-tasks').outerHeight() : 0;
        }

        return toolbarsHeight;
      }

      function cardCurrencyChange() {
        // Update classes to change datepicker icon.
        $('#edit-card-currency option').each(function (index, value) {
          $('#edit-transaction-date-row').removeClass('card-currency--' + $(value).attr('value'));
        });
        $('#edit-transaction-date-row').addClass('card-currency--' + $('#edit-card-currency').val());

        // Hide matching currency.
        $('#edit-transaction-currency option').removeClass('optInvisible ');
        if ($('#edit-card-currency').val() !== '') {
          $('#edit-transaction-currency option[value="' + $('#edit-card-currency').val() + '"]').addClass('optInvisible ');
        }
        $('#edit-transaction-currency').trigger('change.select2');

        // Clear results.
        clearResults();
      }

      function transationCurrencyChange() {

        // Hide matching currency.
        $('#edit-card-currency option').removeClass('optInvisible ');
        if ($('#edit-transaction-currency').val() !== '') {
          $('#edit-card-currency option[value="' + $('#edit-transaction-currency').val() + '"]').addClass('optInvisible ');
        }
        $('#edit-card-currency').trigger('change.select2');

        // Clear results.
        clearResults();
      }

      function clearForm() {
        $('#edit-card-currency').val('').trigger('change');
        $('#edit-transaction-currency').val('').trigger('change');
        $('#edit-transaction-date__altdatepicker').val('');
        $('#edit-transaction-date').val('');
        $('#edit-transaction-amount').val('');
        clearResults();
      }

      function clearResults() {
        $('#edit-your-exchange-rate,#edit-total-cost').val('');
        $('#edit-information-eea-currencies').removeClass('show-eea-info').slideUp();
      }

      function submitForm() {
        // Add submitting mask.
        $('.webform-submission-visa-exchange-rate-calculator-re-form').append('<div class="calculating-mask"></div>');
        $('.webform-submission-visa-exchange-rate-calculator-re-form .calculating-mask').fadeIn(200);

        // Temporarily un-disable elements before serialize.
        var disabledElements = $('.webform-submission-visa-exchange-rate-calculator-form').find(':input:disabled').removeAttr('disabled');

        // Submit Ajax.
        $.ajax({
          type: 'POST',
          data: $('.webform-submission-visa-exchange-rate-calculator-form').serialize(),
          dataType: 'json',
          url: drupalSettings.path.baseUrl + 'ajax/visa-exc-rate-calculate',
          success: function(response) {
            updateResults(response);
          },
        });

        // Re-disable elements after serialize.
        disabledElements.attr('disabled','disabled');
      }

      function updateResults(response) {
        // Put the results
        if (response.success) {
          $('#edit-your-exchange-rate').val(response.results.exchange_rate);
          $('#edit-total-cost').val(response.results.total_cost);
          $('#visa-fee-markup').text(response.results.fee);
        }

        // Check to show eea info.
        if (response.results.fee != '' && $('#edit-transaction-currency option[value="' + $('#edit-transaction-currency').val() + '"]:last').closest('optgroup').prop('label') == 'EEA Currencies') {
          $('#edit-information-eea-currencies').addClass('show-eea-info').slideDown();
        }

        // Fade out submitting mask.
        $('.webform-submission-visa-exchange-rate-calculator-re-form .calculating-mask').fadeOut(400, function (){
          $(this).remove();
        });

        // Scroll to results, and hide header.
        if ($(window).outerWidth() <= 767) {
          $('body').addClass('mbo-nav-001-prevent-header-popudown');
          $('html, body').animate({
            scrollTop: $('.webform-submission-visa-exchange-rate-calculator-re-form').offset().top - getToolbarsHeight()
          }, 500, function() {
            $('body').removeClass('mbo-nav-001-prevent-header-popudown');
          });
        }
      }

      function select2HiddenOptions(data, container) {
        if(data.element) {
          $(container).addClass($(data.element).attr('class'));
        }
        return data.text;
      }

      // =======================================================================

      $('#edit-card-currency').once('visa-exc-rate-calc--card-curr-change').change(function () {
        cardCurrencyChange();
      });
      if ($('#edit-card-currency').hasClass("select2-hidden-accessible")) {
        $(document, context).once('visa-exc-rate-calc--card-curr-onload').each(function() {
          cardCurrencyChange();
        });
        $('#edit-card-currency').once('visa-exc-rate-calc--card-curr-select2').select2({
          templateResult: select2HiddenOptions
        });
      }

      $('#edit-transaction-currency').once('visa-exc-rate-calc--trans-curr-change').change(function () {
        transationCurrencyChange();
      });
      if ($('#edit-transaction-currency').hasClass("select2-hidden-accessible")) {
        $(document, context).once('visa-exc-rate-calc--trans-curr-onload').each(function() {
          transationCurrencyChange();
        });
        $('#edit-transaction-currency').once('visa-exc-rate-calc--trans-curr-select2').select2({
          templateResult: select2HiddenOptions
        });
      }

      $('.visa-exc-rate-calc-forms .paragraph--type--mbm-button-001 .mba-button:eq(0)').once('visa-exc-rate-calc--button-calculate').click(function(){
        $('form.webform-submission-visa-exchange-rate-calculator-form input[type="submit"]').trigger('click');
        return false;
      });
      $('.visa-exc-rate-calc-forms .paragraph--type--mbm-button-001 .mba-button:eq(1)').once('visa-exc-rate-calc--button-clear').click(function(){
        clearForm();
        return false;
      });

      $('body').once('visa-exc-rate-calc--form-submit').on('submit', 'form.webform-submission-visa-exchange-rate-calculator-form', function () {
        submitForm();
        return false;
      });

      $('body').once('edit-transaction-amount-keyup').on('keyup', '#edit-transaction-amount', function(){
        $('#edit-transaction-amount-tablet').val($(this).val());
      });
      $('body').once('edit-transaction-amount-tablet-keyup').on('keyup', '#edit-transaction-amount-tablet', function(){
        $('#edit-transaction-amount').val($(this).val());
      });
      $('#edit-transaction-amount').closest('.webform-flex').addClass('d-block d-sm-flex d-md-none d-xl-flex');
      $('#edit-transaction-amount-tablet').closest('.webform-flex').addClass('d-none d-md-flex d-xl-none');


    }
  }; // Drupal.behaviors.visa_exchange_rate_calculator

})(jQuery, Drupal, drupalSettings);

